var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "deposit detail" },
    [
      _vm.lang == _vm.$config.LANG_KOR
        ? [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(0),
                _vm._m(1),
                true
                  ? _c("div", { staticClass: "summary" }, [_vm._m(2)])
                  : _vm._e()
              ]),
              _vm._m(3)
            ])
          ]
        : _vm.lang == _vm.$config.LANG_ENG
        ? [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(4),
                _vm._m(5),
                true
                  ? _c("div", { staticClass: "summary" }, [_vm._m(6)])
                  : _vm._e()
              ]),
              _vm._m(7)
            ])
          ]
        : [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(8),
                _vm._m(9),
                true
                  ? _c("div", { staticClass: "summary" }, [_vm._m(10)])
                  : _vm._e()
              ]),
              _vm._m(11)
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("기업정기적금")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(" 매월 일정한 금액을 저축하여 목돈을 마련하는 적립식 상품 ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item item-row" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("USD")]),
        _c("span", { staticClass: "text" }, [_vm._v("최대 연")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 3.85% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("상품유형")]),
        _c("dd", [_vm._v("Installment Savings Account")]),
        _c("dt", [_vm._v("상품개요")]),
        _c("dd", [
          _vm._v("매월 일정한 금액을 저축하여 목돈을 마련하는 적립식 상품")
        ]),
        _c("dt", [_vm._v("가입대상")]),
        _c("dd", [_vm._v("캄보디아 내 현지법인")]),
        _c("dt", [_vm._v("계약기간")]),
        _c("dd", [_vm._v("6개월~ 3년 이내에서 월단위")]),
        _c("dt", [_vm._v("가입통화")]),
        _c("dd", [_vm._v("USD")]),
        _c("dt", [_vm._v("가입금액")]),
        _c("dd", [
          _vm._v("신규가입 시 최저 USD 10.00 이상 USD 10.00 단위로 예치")
        ]),
        _c("dt", [_vm._v("금리 및 이율")]),
        _c("dd")
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("약정이율")]),
        _c("p", [_vm._v("통화 : USD")])
      ]),
      _c("div", { staticClass: "tbl-top-etc" }, [
        _vm._v("(연이율, 세전, 단위%)")
      ]),
      _c("table", { staticClass: "table -type01" }, [
        _c("thead", [
          _c("tr", [
            _c(
              "th",
              { staticClass: "col", attrs: { rowspan: "1", scope: "col" } },
              [_vm._v("Term Deposit")]
            ),
            _c("th", { attrs: { scope: "col", colspan: "2" } }, [
              _vm._v("예금이율")
            ])
          ])
        ]),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("6개월 ~ 12개월미만")]),
            _c("td", [_vm._v("3.05")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("1년이상 ~ 2년미만")]),
            _c("td", [_vm._v("3.50")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("2년이상 ~ 3년미만")]),
            _c("td", [_vm._v("3.70")])
          ]),
          _c("tr", [_c("td", [_vm._v("3년이상")]), _c("td", [_vm._v("3.85")])])
        ])
      ]),
      _c("br"),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("중도해지이율")]),
        _c("p", [_vm._v("통화 : USD")])
      ]),
      _c("div", { staticClass: "tbl-top-etc" }, [
        _vm._v("(연이율, 세전, 단위%)")
      ]),
      _c("table", { staticClass: "table -type01" }, [
        _c("thead", [
          _c("tr", [
            _c(
              "th",
              { staticClass: "col", attrs: { rowspan: "1", scope: "col" } },
              [_vm._v("Term Deposit")]
            ),
            _c("th", { attrs: { scope: "col", colspan: "2" } }, [
              _vm._v("예금이율")
            ])
          ])
        ]),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("1개월 ~ 6개월미만")]),
            _c("td", [_vm._v("0.10")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("6개월 ~ 12개월미만")]),
            _c("td", [_vm._v("0.50")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("1년이상 ~ 2년미만")]),
            _c("td", [_vm._v("1.00")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("2년이상 ~ 3년미만")]),
            _c("td", [_vm._v("1.70")])
          ]),
          _c("tr", [_c("td", [_vm._v("3년이상")]), _c("td", [_vm._v("2.00")])])
        ])
      ]),
      _c("div", { staticClass: "info info-type3" }, [
        _c("p", [_vm._v("· 만기이후이율 : 연+2%")])
      ]),
      _c("br"),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("수수료")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("가입방법")]),
        _c("p", [_vm._v("영업점가입, 인터넷 가입")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("가입시 필요서류")]),
        _c("p", [
          _vm._v(
            " 대표자 내점시 : 사업허가증, 법인등기부등본, 사업자등록증, 정관, 주총결의서, 여권 사본 등"
          ),
          _c("br"),
          _vm._v(
            " 대리인 내점시 : 사업허가증, 법인등기부등본, 사업자등록증, 정관, 주총결의서, 여권 사본, 위임장 및 대리인 실명확인증"
          ),
          _c("br"),
          _vm._v(
            " ·위임장에는 신청직원의 인적사항 및 위임내용이 기재되어야 하며, 법인인감날인이 필요합니다. "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("Corporate Installment savings account")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(
          " An installment product to build savings by depositing a fixed amount every month "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item item-row" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("USD")]),
        _c("span", { staticClass: "text" }, [_vm._v("Maximum ")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 3.85% annually ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("Types")]),
        _c("dd", [_vm._v("Installment Savings Account")]),
        _c("dt", [_vm._v("About the products")]),
        _c("dd", [
          _vm._v(
            "An installment product to build savings by depositing a fixed amount every month"
          )
        ]),
        _c("dt", [_vm._v("Eligibilty")]),
        _c("dd", [_vm._v("Corporation in Cambodia")]),
        _c("dt", [_vm._v("Contract Terms")]),
        _c("dd", [_vm._v("6 months ~ 3 years on a monthly basis")]),
        _c("dt", [_vm._v("Available currency")]),
        _c("dd", [_vm._v("USD")]),
        _c("dt", [_vm._v("Deposit amount")]),
        _c("dd", [
          _vm._v(
            "To open a new account, deposit a minimum of USD 10.00 (in unit of USD 10.00)"
          )
        ]),
        _c("dt", [_vm._v("Rates")]),
        _c("dd")
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("The agreed interest rate")]),
        _c("p", [_vm._v("Currency : USD")])
      ]),
      _c("div", { staticClass: "tbl-top-etc" }, [
        _vm._v("(annual interest rate, pretax, unit : %)")
      ]),
      _c("table", { staticClass: "table -type01" }, [
        _c("thead", [
          _c("tr", [
            _c(
              "th",
              { staticClass: "col", attrs: { rowspan: "1", scope: "col" } },
              [_vm._v("Term Deposit")]
            ),
            _c("th", { attrs: { scope: "col", colspan: "2" } }, [
              _vm._v("Savings interest rate")
            ])
          ])
        ]),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("6 months ~ less than 12 months")]),
            _c("td", [_vm._v("3.05")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("More than 1 year ~ less than 2 years")]),
            _c("td", [_vm._v("3.50")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("More than 2 years ~ less than 3 years")]),
            _c("td", [_vm._v("3.70")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("More than 3 years")]),
            _c("td", [_vm._v("3.85")])
          ])
        ])
      ]),
      _c("br"),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Interest rate for an early termination")]),
        _c("p", [_vm._v("Currency : USD")])
      ]),
      _c("div", { staticClass: "tbl-top-etc" }, [
        _vm._v("(annual interest rate, pretax, unit : %)")
      ]),
      _c("table", { staticClass: "table -type01" }, [
        _c("thead", [
          _c("tr", [
            _c(
              "th",
              { staticClass: "col", attrs: { rowspan: "1", scope: "col" } },
              [_vm._v("Term Deposit")]
            ),
            _c("th", { attrs: { scope: "col", colspan: "2" } }, [
              _vm._v("Savings interest rate")
            ])
          ])
        ]),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("1 month ~ less than 6 months")]),
            _c("td", [_vm._v("0.10")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("6 months ~ less than 12 months")]),
            _c("td", [_vm._v("0.50")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("More than 1 year ~ less than 2 years")]),
            _c("td", [_vm._v("1.00")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("More than 2 years ~ less than 3 years")]),
            _c("td", [_vm._v("1.70")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("More than 3 years")]),
            _c("td", [_vm._v("2.00")])
          ])
        ])
      ]),
      _c("div", { staticClass: "info info-type3" }, [
        _c("p", [_vm._v("· Interest rate after the maturity : +2% annually")])
      ]),
      _c("br"),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Fees")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("How to apply")]),
        _c("p", [_vm._v("Apply at the branch, Apply Online")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Required documents for application")]),
        _c("p", [
          _vm._v(
            " When a representative visits : business license, certified copy of corporate registration, business registration card, articles of incorporation, written resolution of general stockholders meeting, a copy of passport, etc."
          ),
          _c("br"),
          _vm._v(
            " When a surrogate visits : business license, certified copy of corporate registration, business registration certificate, articles of incorporation, written resolution of general stockholders meeting, a copy of passport, a letter of attorney and surrogate's ID"
          ),
          _c("br"),
          _vm._v(
            " ·A letter of attorney is required to have a surrogate's personal information and contents of dlegation, and corporate seal "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("គណនីសន្សំថេរសំរាប់ក្រុមហ៊ុន")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(" ការសន្សំប្រាក់រាល់ខែដើម្បីទទួលបានចំនួនទឹកប្រាក់ច្រើន ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item item-row" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("USD")]),
        _c("span", { staticClass: "text" }, [_vm._v("ក្នុងមួយឆ្នាំ ")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 3.85% ជាអតិបរមា ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("ប្រភេទផលិតផល")]),
        _c("dd", [_vm._v("គណនីសន្សំថេរមានកាលកំណត់")]),
        _c("dt", [_vm._v("មាតិកាផលិតផល")]),
        _c("dd", [
          _vm._v("ការសន្សំប្រាក់រាល់ខែដើម្បីទទួលបានចំនួនទឹកប្រាក់ច្រើន")
        ]),
        _c("dt", [_vm._v("អតិថិជនគោលដៅ")]),
        _c("dd", [_vm._v("សហគ្រាស")]),
        _c("dt", [_vm._v("រយៈពេលកិច្ចសន្យា")]),
        _c("dd", [_vm._v("ពី៦ខែ ដល់៣ឆ្នាំ")]),
        _c("dt", [_vm._v("ប្រភេទរូបិយប័ណ្ណដែលស្នើសុំ")]),
        _c("dd", [_vm._v("USD")]),
        _c("dt", [_vm._v("ចំនួនទឹកប្រាក់ដែលស្នើសុំ")]),
        _c("dd", [
          _vm._v("ចំនួនទឹកប្រាក់ដំបូងតិចបំផុត USD10.00 (ឯកត្តាUSD10.00)")
        ]),
        _c("dt", [_vm._v("អត្រាការប្រាក់")]),
        _c("dd")
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("ការប្រាក់ក្នុងកិច្ចសន្យា")]),
        _c("p", [_vm._v("រូបិយវត្ថុ : USD")])
      ]),
      _c("div", { staticClass: "tbl-top-etc" }, [
        _vm._v("(ការប្រាក់ប្រចាំឆ្នាំ, បង់ពន្ធជាមុន, ខ្នាត : %)")
      ]),
      _c("table", { staticClass: "table -type01" }, [
        _c("thead", [
          _c("tr", [
            _c(
              "th",
              { staticClass: "col", attrs: { rowspan: "1", scope: "col" } },
              [_vm._v("រយៈពេល")]
            ),
            _c("th", { attrs: { scope: "col", colspan: "2" } }, [
              _vm._v("ការប្រាក់ក្នុងការបញ្ចូលប្រាក់")
            ])
          ])
        ]),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("ពី៦ខែ ដល់តិចជាង១ឆ្នាំ")]),
            _c("td", [_vm._v("3.05")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("ពី១ឆ្នាំ ដល់តិចជាង២ឆ្នាំ")]),
            _c("td", [_vm._v("3.50")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("ពី២ឆ្នាំ ដល់តិចជាង៣ឆ្នាំ")]),
            _c("td", [_vm._v("3.70")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("លើសពី៣ឆ្នាំ")]),
            _c("td", [_vm._v("3.85")])
          ])
        ])
      ]),
      _c("br"),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [
          _vm._v("ការប្រាក់នៅពេលលុបចោលការសន្សំប្រាក់នៅពាក់កណ្តាល")
        ]),
        _c("p", [_vm._v("រូបិយវត្ថុ : USD")])
      ]),
      _c("div", { staticClass: "tbl-top-etc" }, [
        _vm._v("(ការប្រាក់ប្រចាំឆ្នាំ, បង់ពន្ធជាមុន, ខ្នាត : %)")
      ]),
      _c("table", { staticClass: "table -type01" }, [
        _c("thead", [
          _c("tr", [
            _c(
              "th",
              { staticClass: "col", attrs: { rowspan: "1", scope: "col" } },
              [_vm._v("រយៈពេល")]
            ),
            _c("th", { attrs: { scope: "col", colspan: "2" } }, [
              _vm._v("ការប្រាក់ក្នុងការបញ្ចូលប្រាក់")
            ])
          ])
        ]),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("ពី1ខែ ដល់តិចជាង៦ខែ")]),
            _c("td", [_vm._v("0.10")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("ពី៦ខែ ដល់តិចជាង1ឆ្នាំ")]),
            _c("td", [_vm._v("0.50")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("ពី១ឆ្នាំ ដល់តិចជាង២ឆ្នាំ")]),
            _c("td", [_vm._v("1.00")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("ពី២ឆ្នាំ ដល់តិចជាង៣ឆ្នាំ")]),
            _c("td", [_vm._v("1.70")])
          ]),
          _c("tr", [
            _c("td", [_vm._v("លើសពី៣ឆ្នាំ")]),
            _c("td", [_vm._v("2.00")])
          ])
        ])
      ]),
      _c("div", { staticClass: "info info-type3" }, [
        _c("p", [_vm._v("· ការប្រាក់បន្ទាប់ពីផុតកំនត់: ក្នុងមួយឆ្នាំ +2%")])
      ]),
      _c("br"),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("កំរៃសេវា")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("របៀបចុះឈ្មោះ")]),
        _c("p", [_vm._v("ចុះឈ្មោះនៅសាខា, ចុះឈ្មោះតាមអ៊ីនធឺណិត")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("តំរូវការឯកសារចុះឈ្មោះ")]),
        _c("p", [
          _vm._v(" - លិខិតអនុញ្ញាតបើកអាជីវកម្ម"),
          _c("br"),
          _vm._v(" - អាជ្ញាប័ណ្ណប្រកបអាជីវកម្ម និង ប័ណ្ណប៉ាតង"),
          _c("br"),
          _vm._v(" ់ - សេចក្ដីសម្រេចរបស់ក្រុមប្រឹក្សាភិបាល"),
          _c("br"),
          _vm._v(" - ក្ខន្តិកៈក្រុមហ៊ុន"),
          _c("br"),
          _vm._v(
            " - អត្ដសញ្ញាណប័ណ្ណ រឺ លិខិតឆ្លងដែនច្បាប់ដើមរបស់អភិបាល និង អ្នកទទួលសិទ្ឋិប្រសិនមាន។ "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }